
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gztjnhxOT8RMJlqxIFS_45hlo6uguRH6Svltm5p0SwkOEUMeta } from "/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index1eMCdBj3dHcD9j7ahoHYfJ55_cIx06DrtBRxlSleOdwMeta } from "/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchAG1fhFgYlQtvsKyMHeWsatxmeEzCeMComlhtPnS60lgMeta } from "/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexFA7UmqNTseTUXk1l0KJae9h8eJ7Mn7OvqQ6EEuGRRYYMeta } from "/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93fwMxnGhLv4Pvrq7yZqt_454aoARA1ABMb8MaOnC7lz1AAMeta } from "/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexHVwXRyp8rF16D0Bn8YQXMUS6ogD8yET6iJSGQyZB1GAMeta } from "/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93tZszdaeiid_45Bf1zqKGVFj4ZyHInrJw1bZMfCkwrNRs4Meta } from "/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexTv9MOb7vzE8ZSTeJOLsCemX8H0WNohhQKwhpBEtqORkMeta } from "/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93Vj6zb0g1s2Vd6_45swmjBLb5aH0QgANprw0r5msJtoz_454Meta } from "/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexJ_A5yV0_udxRAoTy4RL4XPeaYhdeCMQeDw8j_jydYIcMeta } from "/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index54UaPWl_45EA6Pf7QLP0fbtI2c_45chA2BGLCBQ0quBm5j8Meta } from "/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexHVwXRyp8rF16D0Bn8YQXMUS6ogD8yET6iJSGQyZB1GAMeta || {},
    component: () => import("/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexTv9MOb7vzE8ZSTeJOLsCemX8H0WNohhQKwhpBEtqORkMeta || {},
    component: () => import("/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexJ_A5yV0_udxRAoTy4RL4XPeaYhdeCMQeDw8j_jydYIcMeta || {},
    component: () => import("/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index54UaPWl_45EA6Pf7QLP0fbtI2c_45chA2BGLCBQ0quBm5j8Meta || {},
    component: () => import("/codebuild/output/src2885690199/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]